import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment, UrlTree, Route } from '@angular/router';
import {Observable} from "rxjs";
import { AuthenticationService, AuthorizationService } from '../../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(
    private readonly _router: Router, 
    private readonly _authenticationService: AuthenticationService,
    private readonly AuthorizationService : AuthorizationService
  ) {}

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this._authenticationService.currentUserValue;

    if (currentUser) {
      if (!this._authenticationService.isTokenNoValid()) {
        // this.AuthorizationService.cargarPermisos().then(() => {
        //   console.log('Permisos cargados correctamente');
        // }).catch((error) => {
        //   // console.error('Error al cargar permisos:', error);
        // });
        console.log('1')
        return true;
      }else{
        console.log('2')
        this._router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    }
    console.log('3')
    // not logged in so redirect to login page with the return url
    this._router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser = this._authenticationService.currentUserValue;
    // if (currentUser) {
    //   if (!this._authenticationService.isTokenNoValid()) {
    //     // authorised so return true
    //     return true;
    //   }else{
    //     return false;
    //   }
    // }
    // not logged in so redirect to login page with the return url
    return true;
  }
}
